import React from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import DoughChart from 'routes/vendorRe/components/DoughChart';
import VerticalChart from 'routes/vendorRe/components/VerticalChart';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import { commonFontWeight700, contentEnd, contentStart, infoEm, infoFontColor4, infoFontSize1, infoFontSize2, statsOuterPadding, statsPaddingMiddle } from './commonConst';
import maleDot from 'routes/vendorRe/images/male_dot.png';
import femailDot from 'routes/vendorRe/images/female_dot.png';

const SettlementStat = () => {
    return (
        <VerticalFlex backgroundColor="white" borderRadius={infoEm} padding={statsOuterPadding}>
            <FlexChild>
                <HorizontalFlex>
                    <FlexChild padding="0 0 1em 0">
                        <P weight={commonFontWeight700} size={infoFontSize1} padding="0 1em 0 0">구매자 통계</P>
                        <P size={infoFontSize2} color={infoFontColor4}>(2024년 3월 기준)</P>
                    </FlexChild>
                </HorizontalFlex>
            </FlexChild>
            <FlexChild>
                {/* 도넛 그래프 영역 */}
                <div className={styles.commonPadd}>
                    <DoughChart />
                </div>
            </FlexChild>
            <FlexChild>
                <VerticalFlex>
                    <FlexChild>
                        <div className={styles.maleBox}>
                            <HorizontalFlex padding={statsPaddingMiddle}>
                                <FlexChild>
                                    <P size={infoFontSize2}>
                                        <img className={styles.genderDots} src={maleDot} alt='남성' />
                                        남성
                                    </P>
                                </FlexChild>
                                <FlexChild justifyContent={contentEnd}>
                                    <P size={infoFontSize2}>347명</P>
                                </FlexChild>
                            </HorizontalFlex>
                        </div>
                    </FlexChild>
                    <FlexChild>
                        <div className={styles.femaleBox}>
                            <HorizontalFlex padding={statsPaddingMiddle}>
                                <FlexChild>
                                    <P size={infoFontSize2}>
                                        <img className={styles.genderDots} src={femailDot} alt='여성' />
                                        여성
                                    </P>
                                </FlexChild>
                                <FlexChild justifyContent={contentEnd}>
                                    <P size={infoFontSize2}>95명</P>
                                </FlexChild>
                            </HorizontalFlex>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
            <FlexChild padding="2em 0 1em" alignItems={contentStart}>
                <P weight={commonFontWeight700} size={infoFontSize1} padding="0 1em 0 0">연령 통계</P>
            </FlexChild>
            <FlexChild>
                {/* 막대 그래프 영역 */}
                <VerticalChart />
            </FlexChild>
        </VerticalFlex>
    );
};

export default SettlementStat;